module.exports = __webpack_public_path__ + "img/business_risk_03.26b85e57.png";